import React, { useRef } from "react"
import Proptypes from 'prop-types'
import { graphql, useStaticQuery } from "gatsby"
import swal from "sweetalert"
import { useForm } from "react-hook-form"

import PreviewCompatibleImage from "../PreviewCompatibleImage"

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const DownloadChecklist = ({ name }) => {
  const { register, handleSubmit, errors } = useForm()
  const downloadChecklistForm = useRef(null)
  const buttonName = `download-checklist-${name}`;

  const onSubmit = data => {
    // post data using fetch to submit data properly
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode(data),
    })
      .then(() => {
        swal({
          title: "Thank You!",
          text: "We Have Received Your Enquiry",
          icon: "success",
          button: "Close",
        })
        downloadChecklistForm.current.reset()
      })
      .catch(error =>
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        })
      )
  }

  const data = useStaticQuery(graphql`
    query {
      markdownRemark(
        frontmatter: { sectionKey: { eq: "sections/download-checklist" } }
      ) {
        frontmatter {
          title
          description
          imageAlt
          image {
            childImageSharp {
              fluid(quality: 100, maxWidth: 600) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  const { frontmatter } = data.markdownRemark

  return (
    <div className="container section-gap">
      <div className="row align-items-center">
        <div className="col-lg-5">
          <div className="d-flex align-items-start justify-content-center">
            <PreviewCompatibleImage
              alt={frontmatter.imageAlt}
              src={frontmatter.image}
            />
          </div>
        </div>
        <div className="col-lg-7">
          <div className="d-flex flex-column">
            <h2 className="mb-4 text-center text-lg-left">
              {frontmatter.title}
            </h2>
            <p className="mb-4 text-center text-lg-left">
              {frontmatter.description}
            </p>
            <form
              ref={downloadChecklistForm}
              data-netlify="true"
              name="download-checklist-form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <input
                type="hidden"
                name="form-name"
                ref={register()}
                value="download-checklist-form"
              />
              <div className="form-row align-items-center">
                <div className="col-auto flex-grow-1 mb-3">
                  <input
                    type="email"
                    ref={register({ required: true })}
                    name="clientEmail"
                    className="form-control form-control-lg"
                    placeholder="Your Email"
                  />
                  {errors.clientEmail && (
                    <span className="text-danger">Required</span>
                  )}
                </div>
                <div className="col-auto flex-grow-1 mb-3">
                  <button
                    type="submit"
                    className={`btn btn-md btn-block btn-secondary ${buttonName}`}
                  >
                    Download
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

DownloadChecklist.propTypes = {
  name: Proptypes.string.isRequired
}

export default DownloadChecklist
